import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {Pressable, View} from 'native-base';
import React from 'react';
import {Platform} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

import {FCC} from '../../../types';
import {useTheme} from 'styled-components/native';

export interface ModalWrapperProps {
  onClosePress: () => void;
}

export const ModalWrapper: FCC<ModalWrapperProps> = props => {
  const {children, onClosePress} = props;
  const theme = useTheme();
  const isDesktop = useIsDesktop();

  return (
    <SafeAreaView
      style={{flex: 1, backgroundColor: isDesktop ? 'lightGrey' : 'white'}}>
      <View
        width={'100%'}
        flex={1}
        alignItems="center"
        justifyContent={isDesktop ? 'center' : undefined}
        bgColor={isDesktop ? 'lightGrey' : 'white'}
        margin="auto"
        minHeight={Platform.OS === 'web' ? '100vh' : undefined}>
        {children}
      </View>
      <Pressable
        position="absolute"
        mr={4}
        mt={4}
        zIndex={999}
        top={Platform.OS !== 'web' ? '6' : '0'}
        right={Platform.OS !== 'web' ? '2' : '0'}
        alignSelf="flex-end"
        testID="go-back-button"
        onPress={onClosePress}>
        <Icon
          name={'times'}
          size={theme.fontSizes[8]}
          color={theme.colors.tuna}
          light
        />
      </Pressable>
    </SafeAreaView>
  );
};
